module.exports = __webpack_public_path__ + "static/sell-5f58ee5f08ff98079dff932eb5325913.svg";